const singleMemberObject = {};

export default {
  init() {},

  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/single-member.js